const getCountryValue = (countriesValue, env) => {
  const country = process.env[env || 'REACT_APP_COUNTRY'] || 'RU';

  return countriesValue[country.toLowerCase()] || '';
}

export default getCountryValue;